module.exports = __webpack_public_path__ + "static/img/car_12_5_cold@3x.766d43dd.png";